import { EXPIRED_DELIVERABLE_HINT, EXPIRED_DOCUMENT_HINT } from '../../constant/document.expiration.constant';

export const isExpiredDocument = (document) => document?.expired === true;

export const expiredDocumentHint = ({ isDeliverable } = {}) => (isDeliverable ? EXPIRED_DELIVERABLE_HINT : EXPIRED_DOCUMENT_HINT);

export const selectedDownloadableDocuments = (documents) => documents.filter((document) => document.checked && !isExpiredDocument(document));
